/* AppTile.styles.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["as", "style"],
  _excluded9 = ["children"],
  _excluded10 = ["as", "style"],
  _excluded11 = ["as", "style"],
  _excluded12 = ["as", "style"],
  _excluded13 = ["as", "style"],
  _excluded14 = ["as", "style"],
  _excluded15 = ["as", "style"],
  _excluded16 = ["as", "style"],
  _excluded17 = ["as", "style"],
  _excluded18 = ["as", "style"],
  _excluded19 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _84 = "._4t3i1k8s{height:1.5rem}";
const _83 = "._otyru2gc{margin-bottom:var(--ds-space-100,8px)}";
const _82 = "._1n261g80{flex-wrap:wrap}";
const _81 = "._i0dlf1ug{flex-basis:0%}";
const _80 = "._1o9zkb7n{flex-shrink:1}";
const _79 = "._16jlkb7n{flex-grow:1}";
const _78 = "._syazbku0{color:var(--ds-icon-brand,#0c66e4)}";
const _77 = "._t9ec11c6{transform:scale(2.2)}";
const _76 = "@media not all and (min-width:64rem){._1s4pviql{width:2rem}._1kneviql{height:2rem}}";
const _75 = "._4t3iviql{height:2rem}";
const _74 = "._1bsbviql{width:2rem}";
const _73 = "._2rko1kwk{border-radius:.5rem}";
const _72 = "@media not all and (min-width:64rem){._1s4pqf5o{width:3.25rem}._1kneqf5o{height:3.25rem}}";
const _71 = "._4t3i1b9w{height:3.75rem}";
const _70 = "._1bsb1b9w{width:3.75rem}";
const _69 = "._19pku2gc{margin-top:var(--ds-space-100,8px)}";
const _68 = "._1i4q1hna{overflow-wrap:break-word}";
const _67 = "._k48p1nn1{font-weight:400}";
const _66 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _65 = "._sudp1e54{-webkit-box-orient:vertical}";
const _64 = "._5nh5cs5v{line-clamp:2}";
const _63 = "._1yyjcs5v{-webkit-line-clamp:2}";
const _62 = "._1e0ccj1k{display:-webkit-box}";
const _61 = "._1dyznl7k{letter-spacing:.3px}";
const _60 = "._1bto1l2s{text-overflow:ellipsis}";
const _59 = "._4cvr1h6o{align-items:center}";
const _58 = "._1bah1h6o{justify-content:center}";
const _57 = "._bfhk18uv{background-color:initial}";
const _56 = "._2rkou2gc{border-radius:var(--ds-space-100,8px)}";
const _55 = "@media not all and (min-width:64rem){._8fz61k7u{max-width:3.5rem}._1ckq1k7u{max-height:3.5rem}}";
const _54 = "._c71l12bs{max-height:4rem}";
const _53 = "._p12f12bs{max-width:4rem}";
const _52 = "._2rkoebcm{border-radius:.375rem}";
const _51 = "._bfhku67f{background-color:#fff}";
const _50 = "._18m915vq{overflow-y:hidden}";
const _49 = "._1reo15vq{overflow-x:hidden}";
const _48 = "._1yt4v77o{padding:var(--ds-space-025,2px)}";
const _47 = "._zulppxbi{gap:var(--ds-space-200,1pc)}";
const _46 = "._otyrpxbi{margin-bottom:var(--ds-space-200,1pc)}";
const _45 = "._irr3108i:hover{background-color:var(--ds-surface-hovered,#f1f2f4)}";
const _44 = "._1ah3133k:focus-visible{outline-offset:.125rem}";
const _43 = "._1ygb17m3:focus-visible{outline:.125rem solid var(--ds-border-focused,#388bff)}";
const _42 = "._19it1luw{border:.0625rem solid var(--ds-border,#091e4224)}";
const _41 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _40 = "._11q7vuon{background:var(--ds-surface,#fff)}";
const _39 = "._2rko12x7{border-radius:var(--ds-space-075,6px)}";
const _38 = "._1yt41693{padding:var(--ds-space-200,1pc) var(--ds-space-200,1pc)}";
const _37 = "._180d1qw3:active{box-shadow:0 8px 9pt 0 rgba(9,30,66,.15),0 0 1px 0 rgba(9,30,66,.31)}";
const _36 = "._1iohnqa1:active{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _35 = "._c2waglyw:active{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _34 = "._1nrm18uv:active{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _33 = "._j6xt1a0f:active{background:var(--ds-surface-raised-hovered,#f1f2f4)}";
const _32 = "._1dbz1qw3:hover{box-shadow:0 8px 9pt 0 rgba(9,30,66,.15),0 0 1px 0 rgba(9,30,66,.31)}";
const _31 = "._jf4cnqa1:hover{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _30 = "._1bnxglyw:hover{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _29 = "._9oik18uv:hover{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _28 = "._1ejj1qw3:focus-visible{box-shadow:0 8px 9pt 0 rgba(9,30,66,.15),0 0 1px 0 rgba(9,30,66,.31)}";
const _27 = "._1w0vnqa1:focus-visible{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _26 = "._10xfglyw:focus-visible{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _25 = "._vjfr18uv:focus-visible{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _24 = "._1ygbugt7:focus-visible{outline:2px solid var(--ds-border-focused,#388bff)}";
const _23 = "._4t3i1osq{height:100%}";
const _22 = "._1bsb1osq{width:100%}";
const _21 = "._1bah1yb4{justify-content:space-between}";
const _20 = "._2lx21bp4{flex-direction:column}";
const _19 = "._1e0c1txw{display:flex}";
const _18 = "._80omtlke{cursor:pointer}";
const _17 = "._ect418aq{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _16 = "._k48powjs{font-weight:300}";
const _15 = "._kqswh2mm{position:relative}";
const _14 = "._vchhusvi{box-sizing:border-box}";
const _13 = "._ajmmnqa1{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _12 = "._1hmsglyw{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _11 = "._4bfu18uv{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _10 = "._v56416gf{transition:box-shadow .2s ease-in-out}";
const _9 = "._19it14i9{border:1px solid var(--ds-background-accent-gray-subtler,#dcdfe4)}";
const _8 = "._11q7hp5a{background:var(--ds-surface-raised,#fff)}";
const _7 = "._2rkooqnp{border-radius:.75rem}";
const _6 = "._1yt418g3{padding:var(--ds-space-300,24px) var(--ds-space-200,1pc) var(--ds-space-200,1pc) var(--ds-space-200,1pc)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import { BodyNormal, H5 } from '@atlassian/mpac-primitives';
import { Link } from 'react-router-dom';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _5 = "._p12f1dfx{max-width:32.5rem}";
const _4 = "._18u0idpf{margin-left:0}";
const _3 = "._otyridpf{margin-bottom:0}";
const _2 = "._2hwxidpf{margin-right:0}";
const _ = "._19pkidpf{margin-top:0}";
export const AppTileContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "li",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12f1dfx", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppTileContainer.displayName = 'AppTileContainer';
}
export const AppTileLink = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = Link,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt418g3 _2rkooqnp _11q7hp5a _19it14i9 _v56416gf _4bfu18uv _1hmsglyw _ajmmnqa1 _vchhusvi _kqswh2mm _k48powjs _ect418aq _80omtlke _1e0c1txw _2lx21bp4 _1bah1yb4 _1bsb1osq _4t3i1osq _1ygbugt7 _vjfr18uv _10xfglyw _1w0vnqa1 _1ejj1qw3 _9oik18uv _1bnxglyw _jf4cnqa1 _1dbz1qw3 _j6xt1a0f _1nrm18uv _c2waglyw _1iohnqa1 _180d1qw3", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppTileLink.displayName = 'AppTileLink';
}
export const AppTileLinkCompact = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = Link,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_38, _39, _40, _41, _10, _11, _12, _13, _42, _14, _15, _18, _19, _20, _5, _23, _43, _25, _26, _27, _44, _29, _30, _31, _45]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt41693 _2rko12x7 _11q7vuon _zulpu2gc _v56416gf _4bfu18uv _1hmsglyw _ajmmnqa1 _19it1luw _vchhusvi _kqswh2mm _80omtlke _1e0c1txw _2lx21bp4 _p12f1dfx _4t3i1osq _1ygb17m3 _vjfr18uv _10xfglyw _1w0vnqa1 _1ah3133k _9oik18uv _1bnxglyw _jf4cnqa1 _irr3108i", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppTileLinkCompact.displayName = 'AppTileLinkCompact';
}
export const AppTileMainContentWrapper = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_46]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_otyrpxbi", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppTileMainContentWrapper.displayName = 'AppTileMainContentWrapper';
}
export const AppTileHeader = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_47, _19]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulppxbi _1e0c1txw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppTileHeader.displayName = 'AppTileHeader';
}
export const AppTileHeaderCompact = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_41, _19]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulpu2gc _1e0c1txw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppTileHeaderCompact.displayName = 'AppTileHeaderCompact';
}
export const AppLogoWrapper = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_48, _49, _50, _51, _52, _53, _54, _14, _55]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4v77o _1reo15vq _18m915vq _bfhku67f _2rkoebcm _p12f12bs _c71l12bs _vchhusvi _8fz61k7u _1ckq1k7u", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppLogoWrapper.displayName = 'AppLogoWrapper';
}
export const AppLogoWrapperCompact = forwardRef((_ref8, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref8,
    __cmplp = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_48, _56, _57, _19, _58, _59]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4v77o _2rkou2gc _bfhk18uv _1e0c1txw _1bah1h6o _4cvr1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppLogoWrapperCompact.displayName = 'AppLogoWrapperCompact';
}
const H3 = _ref9 => {
  let {
      children
    } = _ref9,
    props = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/_jsx(H5, _objectSpread(_objectSpread({
    as: "h3"
  }, props), {}, {
    children: children
  }));
};
export const Heading = forwardRef((_ref10, __cmplr) => {
  let {
      as: C = H3,
      style: __cmpls
    } = _ref10,
    __cmplp = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_49, _50, _60, _61, _62, _63, _64, _65]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1reo15vq _18m915vq _1bto1l2s _1dyznl7k _1e0ccj1k _1yyjcs5v _5nh5cs5v _sudp1e54", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Heading.displayName = 'Heading';
}
export const Tagline = forwardRef((_ref11, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref11,
    __cmplp = _objectWithoutProperties(_ref11, _excluded11);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_49, _50, _66, _60, _67, _68, _69]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1reo15vq _18m915vq _syaz1gjq _1bto1l2s _k48p1nn1 _1i4q1hna _19pku2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Tagline.displayName = 'Tagline';
}
export const AppLogoStyle = forwardRef((_ref12, __cmplr) => {
  let {
      as: C = "img",
      style: __cmpls
    } = _ref12,
    __cmplp = _objectWithoutProperties(_ref12, _excluded12);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_52, _70, _71, _72]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2rkoebcm _1bsb1b9w _4t3i1b9w _1s4pqf5o _1kneqf5o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppLogoStyle.displayName = 'AppLogoStyle';
}
export const AppLogoStyleSmall = forwardRef((_ref13, __cmplr) => {
  let {
      as: C = "img",
      style: __cmpls
    } = _ref13,
    __cmplp = _objectWithoutProperties(_ref13, _excluded13);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_73, _74, _75, _76]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2rko1kwk _1bsbviql _4t3iviql _1s4pviql _1kneviql", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppLogoStyleSmall.displayName = 'AppLogoStyleSmall';
}
export const AddOnIconCover = forwardRef((_ref14, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref14,
    __cmplp = _objectWithoutProperties(_ref14, _excluded14);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_52, _19, _58, _59, _77, _70, _71, _78, _72]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2rkoebcm _1e0c1txw _1bah1h6o _4cvr1h6o _t9ec11c6 _1bsb1b9w _4t3i1b9w _syazbku0 _1s4pqf5o _1kneqf5o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AddOnIconCover.displayName = 'AddOnIconCover';
}
export const AddOnIconCoverSmall = forwardRef((_ref15, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref15,
    __cmplp = _objectWithoutProperties(_ref15, _excluded15);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_73, _19, _58, _59, _74, _75, _78, _76]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2rko1kwk _1e0c1txw _1bah1h6o _4cvr1h6o _1bsbviql _4t3iviql _syazbku0 _1s4pviql _1kneviql", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AddOnIconCoverSmall.displayName = 'AddOnIconCoverSmall';
}
export const AppNameWrapper = forwardRef((_ref16, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref16,
    __cmplp = _objectWithoutProperties(_ref16, _excluded16);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_79, _80, _81, _49, _50]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppNameWrapper.displayName = 'AppNameWrapper';
}
export const PartnerDetailsWrapper = forwardRef((_ref17, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref17,
    __cmplp = _objectWithoutProperties(_ref17, _excluded17);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_69]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pku2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PartnerDetailsWrapper.displayName = 'PartnerDetailsWrapper';
}
export const RatingsAndInstallsContainer = forwardRef((_ref18, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref18,
    __cmplp = _objectWithoutProperties(_ref18, _excluded18);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_19, _59, _21, _82, _83]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _4cvr1h6o _1bah1yb4 _1n261g80 _otyru2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  RatingsAndInstallsContainer.displayName = 'RatingsAndInstallsContainer';
}
export const NoCertification = forwardRef((_ref19, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref19,
    __cmplp = _objectWithoutProperties(_ref19, _excluded19);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_84]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_4t3i1k8s", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  NoCertification.displayName = 'NoCertification';
}